import { iconFactory } from '../iconFactory'

export const Fire = iconFactory(
  'Fire',
  ({ fill }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.38165 10.8999C5.38165 9.63903 6.25243 8.56097 7.74389 8.35115C8.9896 8.17631 9.29951 7.80914 10.1893 7.23216C10.4266 7.08063 10.8164 7.15056 10.8842 7.3662C11.0791 7.96067 11.1808 8.57845 11.1808 9.20206C11.1893 10.7465 10.337 12.9692 8.09134 12.9692C6.25243 12.9692 5.38165 11.914 5.38165 10.8999ZM9.79317 1.42701C9.55984 1.2011 9.1665 1.41372 9.23317 1.73266C9.35984 2.35725 9.49317 3.18117 9.49317 3.91871C9.49317 5.28749 8.59317 6.39712 7.21984 6.39712C6.19317 6.39712 5.35317 5.77918 4.9865 4.89546C4.91984 4.76257 4.89317 4.68283 4.85317 4.53665C4.77984 4.25758 4.41317 4.1712 4.25317 4.41705C4.13317 4.59645 4.01984 4.77586 3.91317 4.96855C3.11984 6.32403 2.6665 7.90543 2.6665 9.59314C2.6665 12.53 5.05317 14.9088 7.99984 14.9088C10.9465 14.9088 13.3332 12.53 13.3332 9.59314C13.3332 7.2742 12.6132 5.12137 11.3932 3.3207C10.9265 2.63632 10.3932 1.99844 9.79317 1.42701Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
